import { ThumbnailFit, ThumbnailSizePreset } from '../../core-field/media-attachment-field-props'

export { ThumbnailSizePreset, ThumbnailFit }

export const THUMBNAIL_SIZE_PRESETS: Record<ThumbnailSizePreset, number> = {
  sm: 80,
  md: 160,
  lg: 240,
}

export interface FileViewerProps {
  /**
   * Blocks every interaction the viewer offers, the lightbox included.
   * Disabled means disabled: a greyed-out field that still opens a
   * full-screen viewer on tap isn't disabled, it just looks it.
   *
   * Distinct from read-only, which keeps viewing available on purpose —
   * only `isDisabled` blocks.
   */
  isDisabled?: boolean
  value?: any
  /** Literal URI or array of URIs. Takes precedence over `value`. */
  uri?: string | string[]
  entity?: any
  /** Controls thumbnail container height. Presets: sm=80, md=160, lg=240. Number = explicit px/dp. */
  thumbnailSize?: ThumbnailSizePreset | number
  thumbnailFit?: ThumbnailFit
  /** Show the filename as an overlay badge anchored top-left of the thumbnail. */
  showFileName?: boolean
  showDownloadButton?: boolean
  showPrintButton?: boolean
  printOptions?: any
  /** Shown in the empty state when there are no files or images to display. */
  placeholder?: string
  /**
   * When provided, the action overlay includes a trash button that calls back
   * with the index of the file currently in view.
   */
  onRemoveCurrent?: (index: number) => void
}
